import FormElementMixin from '../../../../../spine-appkit-vue/src/components/form/mixins/FormElementMixin';

Vue.asyncComponent('cms-slug-control', {
    mixins: [FormElementMixin],
    data() {
        return {
            editMode: false,
            maxUrlCount: 5,
            visibleUrlCount: 5,
            initialValue: null,
        }
    },
    props: {
        icon: {
            type: String,
        },
        urls: {
            type: Array,
            default: () => [],
        },
        slugPlaceholders: {
            type: Array,
            required: true,
            default: () => [],
        }
    },
    computed: {
        slugForDisplay() {
            const cleanSlug = this.currentValue?.replace(/^\/|\/$/g, "");
            return cleanSlug || 'jouw-slug-hier';
        },
        activeLocaleUrls() {
            const activeLocale = this.$localeHandler.getActiveLocale();
            const out = [];

            this.urls.forEach(urlsByLanguage => {
                if (urlsByLanguage[activeLocale]) {
                    out.push(urlsByLanguage[activeLocale]);
                }
            });

            return out;
        },
        previewUrls() {
            const regex = new RegExp(this.slugPlaceholders.join('|'), 'g');

            return this.activeLocaleUrls
                    .slice(0, this.visibleUrlCount)
                    .map(url => url.replace(regex, this.slugForDisplay));
        },
        currentValue: {
            get() {
                if (this.isLocalized) {
                    return this.localValue[this.$localeHandler.getActiveLocale()];
                }

                return this.localValue;
            },
            set(e) {
                const value = this.slugify(e);
                if (this.isLocalized) {
                    this.localValue[this.$localeHandler.getActiveLocale()] = value;
                } else {
                    this.localValue = value;
                }

                this.$emit('input', this.localValue);
                this.$emit('updateState', this.formatStateOutput(this.localValue));
            }
        }
    },
    methods: {
        refreshSlug(e) {
            e.preventDefault();
            this.$emit('refreshClick');
        },
        toggleEditMode() {
            this.editMode = !this.editMode;

            if (this.editMode) {
                this.$refs.input.focus();
            }
        },
        setVisibleUrlCount(count) {
            this.visibleUrlCount = count;
        },
        openInNewTab(url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        highlightSlug(url) {
            return url.replace(this.slugForDisplay, `<b>${this.slugForDisplay}</b>`);
        },
        slugify(text) {
            if (!text) return '';

            return text
                    .toString()                                               // Ensure the input is a string
                    .toLowerCase()                                            // Convert to lowercase
                    .normalize('NFD')                                   // Split accented characters into base characters and diacritics
                    .replace(/[\u0300-\u036f]/g, '')   // Remove the diacritics (accents)
                    .replace(/[^a-z0-9\s-]/g, '')      // Remove all non-alphanumeric characters (except spaces and hyphens)
                    .replace(/[\s-]+/g, '-')           // Replace spaces and multiple consecutive hyphens with a single hyphen
                    .replace(/^-+|-+$/g, '');          // Trim hyphens from the start and end of the string
        },
        isLegitUrl(url) {
            return this.initialValue && this.activeLocaleUrls.includes(url);
        }
    },
    created() {
        this.initialValue = this.currentValue;
    }
}, 'cms/form/controls/cms-slug-control.html');